import { Module } from 'vuex';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state, IPraxisgruppeRechnungenState } from './state';

export const NAME = 'praxisgruppeRechnungen';
export const store: Module<IPraxisgruppeRechnungenState, IRootState> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};

export default store;
